import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../../../booking/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../../components/ui/dialog";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import { Button } from "../../../components/ui/button";

const TIMES = Array.from({ length: 64 }, (_, i) => {
  const m = 8 * 60 + i * 15;
  return `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
});
const roundDown = (hhmm) => TIMES.filter((t) => t <= hhmm).pop() || TIMES[0];

export const WalkInDialog = ({ target, date, isToday, nowHHMM, services, onClose, onCreated }) => {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  const options = target ? services.filter((s) => s.resource_group_id === target.group?.id || (!target.group && !s.resource_group_id)) : [];

  useEffect(() => {
    if (target) setF({ service_id: options[0]?.id || "", time: isToday ? roundDown(nowHHMM()) : "10:00", name: "", phone: "", guests: 2, notes: "" });
  }, [target]); // eslint-disable-line react-hooks/exhaustive-deps

  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/api/admin/bookings/walk-in", {
        ...f, guests: Number(f.guests), date, resource_unit: target.unit?.name || null, status: "ARRIVED",
      });
      toast.success(`Walk-in ${r.data.code} added${r.data.resource_unit ? ` to ${r.data.resource_unit}` : ""}`);
      onCreated();
      onClose();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="walkin-dialog">
        <DialogHeader><DialogTitle>Walk-in{target?.unit ? ` · ${target.unit.name}` : ""}</DialogTitle></DialogHeader>
        {f && (
          <form onSubmit={submit} className="grid grid-cols-2 gap-3" id="walkin-form">
            <div className="col-span-2">
              <Label>Service</Label>
              <select required value={f.service_id} onChange={set("service_id")} data-testid="walkin-service"
                className="w-full border rounded-md h-9 px-2 text-sm bg-white">
                {options.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
              </select>
            </div>
            <div>
              <Label>Time</Label>
              <select value={f.time} onChange={set("time")} data-testid="walkin-time" className="w-full border rounded-md h-9 px-2 text-sm bg-white">
                {TIMES.map((t) => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div><Label>Guests</Label><Input type="number" min={1} max={30} value={f.guests} onChange={set("guests")} data-testid="walkin-guests" /></div>
            <div className="col-span-2"><Label>Name</Label><Input required value={f.name} onChange={set("name")} data-testid="walkin-name" /></div>
            <div className="col-span-2"><Label>Phone (optional)</Label><Input value={f.phone} onChange={set("phone")} data-testid="walkin-phone" /></div>
            <div className="col-span-2"><Label>Notes</Label><Input value={f.notes} onChange={set("notes")} data-testid="walkin-notes" /></div>
          </form>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button type="submit" form="walkin-form" disabled={busy} data-testid="walkin-submit">Add & check in</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
